import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import { getData } from '../Services/api'
import Pagination from '../Services/Pagination';

const NewsLettersList = () => {
    const [news, setNews] = useState([]);
    const [page, setPage] = useState(1);
    const [pages, setPages] = useState(1);
    const [total, setTotal] = useState(0);
    const fetchNewssLetters = async (pageNumber = 1) => {
        try {
            const res = await getData(`/newsletter/all?page=${pageNumber}`);
            if (res.status) {
                setNews(res.data || []);
                setPage(res.pagination.currentPage);
                setPages(res.pagination.totalPages);
                setTotal(res.pagination.totalRecords);
            }
        } catch (error) {
            console.log("error fetch newsletter page", error)
        }
    }

    useEffect(() => {
        fetchNewssLetters(page);
    }, [page]);

    const handlePageChange = (pageNumber) => {
        if (pageNumber !== page) {
            fetchNewssLetters(pageNumber);
        }
    };

    return (
        <>
            <div className="pc-container">
                <div className="pc-content">
                    <div className="page-header">
                        <div className="page-block">
                            <div className="row align-items-center">
                                <div className="col-md-12">
                                    <ul className="breadcrumb">
                                        <li className="breadcrumb-item">
                                            <Link to="/">Home</Link>
                                        </li>
                                        <li className="breadcrumb-item" aria-current="page">
                                            All NewsLetters
                                        </li>
                                    </ul>
                                </div>
                                <div className="col-md-12">
                                    <div className="page-header-title">
                                        <h2 className="mb-0">All NewsLetters</h2>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-sm-12">
                            <div className="card table-card">
                                <div className="card-body">
                                    <div className="table-responsive">
                                        <table className="table table-hover" id="pc-dt-simple">
                                            <thead>
                                                <tr>
                                                    <th>S.No.</th>
                                                    <th>Email</th>
                                                    <th>Subscribe At</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {
                                                    news?.length > 0 ? (
                                                        news?.map((cms, index) => {
                                                            return (
                                                                <tr key={cms._id}>
                                                                    <td>{index + 1}.</td>
                                                                    <td>
                                                                        <h6 className="mb-0">{cms.email}</h6>
                                                                    </td>
                                                                    <td>
                                                                        {new Date(cms.subscribedAt).toLocaleString('en-US')}
                                                                    </td>
                                                                </tr>
                                                            )
                                                        })
                                                    ) : (
                                                        <tr>
                                                            <td colSpan={6} className='text-center'>No CMS Page Found</td>
                                                        </tr>
                                                    )
                                                }

                                            </tbody>
                                        </table>
                                    </div>
                                    <div className="d-flex justify-content-between align-items-center px-4 pb-3">
                                        <div className="text-muted">
                                            Showing {(page - 1) * 10 + 1} to {Math.min(page * 10, total)} of {total} entries
                                        </div>
                                        <Pagination
                                            page={page}
                                            pages={pages}
                                            onPageChange={handlePageChange}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default NewsLettersList